<template>
  <div id="contents">
    <div class="recruit_young" v-if="young_post">
      <div class="recruit_young_main">
        <div class="title_area">
          <p class="title_area_title">{{ young_post.title }}</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" alt=""/>
        </div>
        <p class="title_area_caption">{{ young_post.caption }}</p>

        <div class="producer" v-for="producer in young_post.producer" :key="producer.id">
          <div class="thumbnail">
            <img :src="producer.image" alt="">
          </div>
          <div class="text_area">
            <p class="info">{{ producer.info }}</p>
            <h4>{{ producer.name }}</h4><p class="name_en">{{ producer.name_en }}</p>
            <img src="../assets/img/common/recruit_2021/young_pink_line.svg" alt="">
            <p class="text" v-html="producer.text"></p>
          </div>
        </div>
        <div class="journals_main">
          <div class="journal" v-for="(journal, index) in young_post.journals" :key="journal.id" :id="'journal_section' + index">

            <div class="even_journal" :style="{'margin-top': journal.margin_top + 'px'}" v-if="index % 2 == 0" :id="journal.anchor_link">
              <div :class="'image_area ' + [journal.image_layout_type === 1 ? 'takada_margin' : '']">
                <div class="image_layout_1_box" v-if="journal.image_layout_type === 1">
                  <img class="image_layout" v-for="images in journal.images" :key="images.id" :src="images.image" alt="">
                  <p  :class="'caption ' + [ journal.anchor_link == 'meeting_takada' ? 'takada_caption' : '' ]" v-html="journal.caption"></p>
                </div>
                <div class="image_layout_2_box" v-if="journal.image_layout_type === 2">
                  <img class="image_layout" :src="journal.image" alt="">
                  <p class="caption" v-html="journal.caption"></p>
                </div>
              </div>
              <div :class="'text_aera ' + [journal.image_layout_type === 1 ? 'small' : '']" :style="{'margin-top': journal.text_margin_top + 'px'}" >
                <p class="title" v-for="title in journal.title" :key="title.id" :class="[ title.padding_right0 == true ? 'padding_right0' : '' ]" v-html="title.text"></p>
                <p class="date">{{ journal.date }}</p>
                <p class="text" v-html="journal.text"></p>
              </div>
            </div>


            <div class="odd_journal" :style="{'margin-top': journal.margin_top + 'px'}" v-if="index % 2 != 0" :id="journal.anchor_link">
              <div :class="'text_aera ' + [journal.image_layout_type === 1 ? 'small' : '']" :style="{'margin-top': journal.text_margin_top + 'px'}">
                <p class="title" v-for="title in journal.title" :key="title.id" :class="[ title.padding_right0 == true ? 'padding_right0' : '' ]">{{ title.text }}</p>
                <p class="date" >{{ journal.date }}</p>
                <p class="text" v-html="journal.text"></p>
              </div>
              <div class="image_area">
                <div class="image_layout_1_box" v-if="journal.image_layout_type === 1">
                  <transition v-for="images in journal.images" :key="images.id">
                    <img class="image_layout" :src="images.image" alt="">
                  </transition>
                  <p :class="'caption ' + [ journal.anchor_link == 'meeting_takada' ? 'takada_caption' : '' ]" v-html="journal.caption"></p>
                </div>
                <div class="image_layout_2_box" v-if="journal.image_layout_type === 2">
                  <img class="image_layout" :src="journal.image" alt="">
                  <p class="caption" v-html="journal.caption"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="relation_movie_list">
        <div class="title">
          <h4>他の若手社員の毎日を見る</h4>
        </div>
        <ul>
          <li v-for="relation_young in young_post.relation_post" :key="relation_young.id" @click="reload_model(relation_young.wakate_id, 'young')">
            <div class="thumbnail">
              <img :src="relation_young.thumbnail" alt="">
            </div>
            <p>{{ relation_young.title }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import young_post_list from './js/recruit_young.json'
export default {
  name: 'recruit_young',
  data() {
    return {
      young_post_list: young_post_list,
      young_post: null,
      request_id: this.$route.params.id,
      loading: false,
      post_list: null,
      error: null,
      reloaded: false,
      anchor_link_timeout: false
    }
  },
  props: [
    'post_type',
    'link'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_young_post(this.$route.params.id)
    //animation
    this.$nextTick(() => {
      var secTopArr = new Array();
      var current = -1;
      $('.journal').each(function (i) {
        secTopArr[i] = $(this).offset().top;
      });
      $(window).scroll(function () {
        for (var i = secTopArr.length-1; i>=0; i--) {
          if ($(window).scrollTop() > secTopArr[i] - 250) {
            if (i != current) {
              $('#journal_section'+i).addClass('move_view');
              current = i;
              break;
            }
          }
        }
      });
    });
  },
  methods: {
    fetch_young_post(request_id){
      this.young_post = this.young_post_list[request_id]
      if (this.post_type != 'all'){
        setTimeout(() => {
          if (this.link){
            var speed = 1500;
            var href = this.link
            var target = $('#' + href)
            var position = target.offset().top - 100;
            $('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
          }
        }, 300);
      }
    },
    reload_model(post_id, layout) {
      var post = this.young_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_young
    &_main
      width: 1000px
      margin: 0 auto
      margin-top: 169px
      padding: 87px 0 59px 0
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -49px
        left: 53px
        &_title
          @include recruit_font(40px, 59px, 7px)
          color: #fff
          background: #8B53AF
          padding: 5px 15px 9px 15px
          display: table
        &_caption
          @include recruit_font(14px, 28px, 2px)
          width: 890px
          margin: 0 57px 0 57px
      .close_icon
        position: absolute
        right: 0px
        top: -73px
        img
          width: 40px
          height: 40px
      .producer
        width: 890px
        margin: 0 auto
        margin-top: 47px
        display: flex
        .thumbnail
          width: 213px
          height: 213px
          img
            width: 213px
            height: 213px
        .text_area
          margin-left: 47px
          width: 619px
          overflow: hidden
          .info
            @include recruit_font(16px, 28px, 3px)
            color: #FF7689
          h4
            @include recruit_font(30px, 46px, 6px)
            color: #FF7689
            margin-top: 10px
          .name_en
            @include recruit_font(17px, 17px, 1px)
            color: #FF7689
            display: inline-block
          img
            margin-top: 23px
            width: 609px
          .text
            @include recruit_font(12px, 23px, 2px)
            padding-top: 10px
            height: 128px
      .journals_main
        .journal
          margin-left: 53px

          .image_area
            position: relative
            overflow: hidden
            opacity: 0
            &::before
              content: ""
              display: block
              position: absolute
              background: #8B53AF
              top: 0
              left: -10%
              width: 150%
              height: 120%
              z-index: 50
              -webkit-transform: skewX(10deg)
              transform: skewX(10deg)

          .text_aera
            .title
              position: relative
              overflow: hidden
              opacity: 0
              &::before
                content: ""
                display: block
                position: absolute
                background: #fff
                top: 0
                left: -10%
                width: 150%
                height: 120%
                z-index: 50
                -webkit-transform: skewX(10deg)
                transform: skewX(10deg)

            .text,.date
              opacity: 0
              position: relative
              top: 60px

          .even_journal
            display: flex
            .image_area
              margin-right: 115px
              &.takada_margin
                margin-right: 66px
              .image_layout_1_box
                width: 427px
                height: 390px
                .image_layout
                  width: 249px
                  height: 249px
                  &:not(:first-child)
                    position: absolute
                    top: 156px
                    left: 178px
                .caption
                  @include recruit_font(12px, 23px, 1px)
                  color: #8B53AF
                  margin-top: 0px
                  height: 52px
                  display: block
                .takada_caption
                  position: absolute
                  top: 180px
              .image_layout_2_box
                .image_layout
                  width: 396px
                  height: 396px
                .caption
                  @include recruit_font(12px, 23px, 1px)
                  color: #8B53AF
                  margin-top: 8px
                  height: 52px
                  display: block
            .text_aera
              width: 482px
              .title
                @include recruit_font(35px, 35px, 4px)
                color: #fff
                background: #8B53AF
                padding: 7px 12px 7px 12px
                display: table
                &:not(:first-child)
                  padding: 7px 12px 7px 12px
                &.padding_right0
                  padding: 7px 0px 7px 12px
              .date
                @include recruit_font(21px, 21px, 4px)
                color: #8B53AF
                margin-top: 24px
              .text
                @include recruit_font(12px, 25px, 2px)
                margin-top: 24px
                width: 425px
            .small
              width: 454px
          .odd_journal
            display: flex
            .image_area
              margin-left: 10px
              img
                width: 396px
                height: 396px
              .image_layout_1_box
                width: 427px
                height: 390px
                .image_layout
                  width: 249px
                  height: 249px
                  &:not(:first-child)
                    position: absolute
                    top: 156px
                    left: 178px
                .caption
                  @include recruit_font(12px, 23px, 1px)
                  color: #8B53AF
                  margin-top: 0px
                  height: 52px
                  display: block
              .caption
                @include recruit_font(12px, 23px, 1px)
                color: #8B53AF
                margin-top: 8px
                height: 52px
              .takada_caption
                position: absolute
                top: 180px
            .text_aera
              width: 482px
              .title
                @include recruit_font(35px, 35px, 3px)
                color: #fff
                background: #8B53AF
                padding: 7px 12px 7px 12px
                display: table
                &:not(:first-child)
                  padding: 7px 12px 7px 12px
                &.padding_right0
                  padding: 7px 0px 7px 12px
              .title.padding_right0
                padding: 7px 0px 7px 12px
              .date
                @include recruit_font(21px, 21px, 4px)
                color: #8B53AF
                margin-top: 24px
              .text
                @include recruit_font(12px, 25px, 2px)
                margin-top: 24px
                width: 425px
            .small
              width: 454px


        //以下,animation
        .move_view
          //image
          .image_area
            opacity: 1

            &::before
              -webkit-animation: fadein1 1.5s 1 ease forwards
              animation: fadein1 1.2s 1 ease forwards

          @keyframes fadein1
            0%
              width: 150%
              left: -12.5%
              opacity: 1
            60%
              width: 150%
              left: 150%
              opacity: 1
            100%
              width: 150%
              left: 150%
              opacity: 0
          .text_aera
            .title
              opacity: 1

              &::before
                -webkit-animation: titilein1 1.2s 1 ease forwards
                animation: titilein1 1.8s 1 ease forwards

            @keyframes titilein1
              0%
                width: 150%
                left: -12.5%
                opacity: 1
              60%
                width: 150%
                left: 150%
                opacity: 1
              100%
                width: 150%
                left: 150%
                opacity: 0
            .text,.date
              -webkit-animation: textin0 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) 1 forwards 0.8s
              animation: textin0 1.5s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s

            @keyframes textin0
              0%
                opacity: 0
                top: 60px
              30%
                opacity: 1
              100%
                opacity: 1
                top: 10px

    .relation_movie_list
      width: 1000px
      margin: 0 auto
      margin-top: 67px
      .title
        display: inline-block
        padding-right: 10px
        height: 48px
        background-color: #fff
        h4
          @include recruit_font(28px, 41px, 5px)
          color: #FF7689
          margin: 0 0 0 13px
      ul
        margin-top: 52px
        margin-bottom: 51px
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        &:after
          content: ""
          display: block
          width: 318px
        li
          width: 318px
          margin-bottom: 59px
          cursor: pointer
          .thumbnail
            width: 318px
            height: 180px
            position: relative
            overflow: hidden
            img
              width: 101%
              position: absolute
              left: 50%
              top: 50%
              transform: translate(-50%, -50%)
              transition: .3s all
            &:hover
              img
                transition-duration: 0.5s
                transform: translate(-50%, -50%) scale(1.1)
          p
            @include recruit_font(12px, 12px, 1px)
            color: #fff
            margin-top: 9px
</style>



// WEBPACK FOOTER //
// src/components/recruit_young.vue